import axiosInstance from '../axiosConfig';
import { API } from '../api';
import { useCustomerAppointmentStore } from '../../zustand-store/customerAppointment.store';
export const getAllLocations = async () => {
  const response = await axiosInstance.get(API.customer_appointment.ALL_LOCATIONS);
  useCustomerAppointmentStore.getState().setAllLocations(response?.data?.data);
  return response?.data?.data;
};

export const getAllLocationsWithSubDomain = async (subdomain) => {
  const response = await axiosInstance.get(
    API.customer_appointment.ALL_LOACTION_SUBDOMAIN + subdomain
  );
  useCustomerAppointmentStore.getState().setAllLocations(response?.data?.data?.locations);
  useCustomerAppointmentStore.getState().changeBusinessName(response?.data?.data?.businessName);
  useCustomerAppointmentStore.getState().changeBusinessLogo(response?.data?.data?.image);

  return response?.data?.data.locations;
};

// Same endpoint as getAllLocationsWithSubDomain, but returns the raw business
// payload (businessName, telephone, etc.) instead of just the locations array -
// used where we need business-level info and there's no location to key off yet,
// e.g. when a customer lands on /appointment without a locationId.
export const getBusinessBySubdomain = async (subdomain) => {
  const response = await axiosInstance.get(
    API.customer_appointment.ALL_LOACTION_SUBDOMAIN + subdomain
  );
  return response?.data?.data;
};

// Same payload as getBusinessBySubdomain, resolved from a location's public
// booking slug instead - used by the /book/:slug journey.
export const getBusinessBySlug = async (slug) => {
  const response = await axiosInstance.get(
    API.customer_appointment.BUSINESS_BY_SLUG + encodeURIComponent(slug)
  );
  return response?.data?.data;
};

export const getAllWorkingDays = async (id) => {
  const response = await axiosInstance.get(API.WORKING_DAYS.ALL_WORKING_DAYS + id);
  return response?.data?.data;
};
export const getAllWorkingDaysForAdmin = async (id) => {
  const response = await axiosInstance.get(API.WORKING_DAYS.ALL_WORKING_DAYS_FOR_ADMIN + id);
  return response?.data?.data;
};

export const getServicesForBackOffice = async (id) => {
  const response = await axiosInstance.get(API.SERVICES.BACK_OFFICE + id);
  // useCustomerAppointmentStore.getState().setAllAppointments(response?.data?.data);
  return response?.data?.data;
};

export const getAllServices = async (id) => {
  const response = await axiosInstance.get(API.SERVICES.ALL_SERVICES + id);
  useCustomerAppointmentStore.getState().setAllAppointments(response?.data?.data);
  return response?.data?.data;
};

export const getAllServicesWithoutFilter = async (id) => {
  const response = await axiosInstance.get(API.SERVICES.ALL_SERVICE_WITHOUT_FILTER + id);
  useCustomerAppointmentStore.getState().setAllAppointments(response?.data?.data);
  return response?.data?.data;
};

export const getAvaliableSlotsByDate = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.AVALIABLE_SLOTS_BY_DATE,
    payload
  );
  return response?.data?.data;
};
/**
 * Rule-aware availability (public). `professionalId` is required for Rule 2 locations and
 * ignored for Rule 1/3 — omit it there. Returns the same "HH:mm - HH:mm" strings as v2.
 * @param {{ date: string, locationId: number, serviceId: number, professionalId?: number }} payload
 */
export const getAvaliableSlotsByDateV3 = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.AVALIABLE_SLOTS_BY_DATE_V3,
    payload
  );
  return response?.data?.data;
};
/**
 * Admin slots for any booking flow: `serviceId` (service only), `professionalId`
 * + `professionalServiceId` (professional first), or `serviceId` +
 * `professionalId` (service + professional).
 * @param {{ date: string, locationId: number, serviceId?: number, professionalId?: number, professionalServiceId?: number }} payload
 */
export const getAvaliableSlotsByDateForAdminV3 = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.AVALIABLE_SLOTS_BY_DATE_FOR_ADMIN_V3,
    payload
  );
  return response?.data?.data;
};

export const getAvaliableSlotsByDateForAdmin = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.AVALIABLE_SLOTS_BY_DATE_FOR_ADMIN,
    payload
  );
  return response?.data?.data;
};

export const createAppoinment = async (payload) => {
  const response = await axiosInstance.post(API.customer_appointment.CREATE_APPOINMNET, payload);
  return response;
};

export const createAppoinmentWithBookingId = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.CREATE_APPOINMNET_BOOKINGID,
    payload
  );
  return response;
};

export const getAppoinmentSummary = async (id) => {
  const response = await axiosInstance.get(API.customer_appointment.APPOINMNET_SUMMARY + id);
  return response;
};
export const createAppoinmentFromDashboard = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.CREATE_APPOINMENT_FROM_DAHBOARD,
    payload
  );
  return response;
};
export const updateAppoinmentFromDashboard = async (payload) => {
  const response = await axiosInstance.patch(
    API.customer_appointment.UPDATE_APPOINMENT_FROM_DAHBOARD,
    payload
  );
  return response;
};

export const makeAppointmentWithoutPayment = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.APPOINTMENT_WITHOUT_PAYMENT,
    payload
  );
  return response?.data?.data;
};
export const updateAppointmentWithoutPayment = async (payload) => {
  const response = await axiosInstance.post(
    API.customer_appointment.UPDATE_APPOINTMENT_WITHOUT_PAYMENT,
    payload
  );
  return response?.data?.data;
};

export const checkAppointmentAvailability = async (startTime, endTime, locationId) => {
  const response = await axiosInstance.get(
    `${API.customer_appointment.CHECK_APPOINTMENT_AVALIABILITY}?startTime=${startTime}&endTime=${endTime}&locationId=${locationId}`
  );
  return response;
};
export const checkAppointmentPaid = async (appointmentId) => {
  const response = await axiosInstance.get(
    `${API.customer_appointment.CHECK_APPOINTMENT_PAID}/${appointmentId}`
  );
  return response;
};

export const getAppointmentPageContent = async (id) => {
  if (!id) return null;
  const response = await axiosInstance.get(API.customer_appointment.PAGE_CONTENT + id);
  return response;
};

export const addAppointmentPageContent = async (data) => {
  const response = await axiosInstance.post(API.customer_appointment.ADD_PAGE_CONTENT, data);
  return response;
};
export const addAppointmentPageRightContent = async (data) => {
  const response = await axiosInstance.post(API.customer_appointment.ADD_PAGE_RIGHT_CPNTENT, data);
  return response;
};

export const getProvitonalBooking = async (id) => {
  const response = await axiosInstance.get(API.customer_appointment.PROVISIONAL_BOOKING + id);
  return response;
};

export const getCustomerInformationByAppointmentId = async (appointmentId) => {
  const response = await axiosInstance.get(
    API.customer_appointment.CUSTOMER_INFORMATION_BY_APPOINTMENT_ID + appointmentId
  );
  return response?.data?.data;
};
